var _polygon, _polygon2, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReturnMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#662ca1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 21.715,33.431 21.715,21.715 10,21.715 21.715,21.715 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#662ca1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 78.283,66.57 78.283,78.283 90,78.283 78.283,78.283 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#662ca1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M78.283,78.283c7.238-7.238,11.715-17.24,11.715-28.285C89.998,27.91,72.09,10,49.999,10c-7.288,0-14.112,1.958-19.996,5.362 C35.886,11.958,42.71,10,49.999,10c22.091,0,40,17.909,40,39.998C89.998,61.043,85.521,71.045,78.283,78.283z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#662ca1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M69.996,84.635C64.111,88.039,57.285,90,49.999,90C27.908,90,10,72.088,10,49.999c0-11.045,4.477-21.046,11.715-28.283 C14.477,28.953,10,38.954,10,49.999C10,72.088,27.908,90,49.999,90C57.285,90,64.111,88.039,69.996,84.635z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#662ca1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M26.909,53.645c3.358,3.357,3.355,8.797,0,12.152l-6.077-6.076L26.909,53.645z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#662ca1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M34.202,73.09c3.355-3.357,8.797-3.357,12.152-0.002l-6.077,6.076L34.202,73.09z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#662ca1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M73.09,46.352c-3.357-3.355-3.355-8.795,0.002-12.154l6.074,6.077L73.09,46.352z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#662ca1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M65.799,26.909c-3.357,3.358-8.799,3.355-12.154,0l6.078-6.077L65.799,26.909z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -20.7112 50.0028)",
    fill: "none",
    stroke: "#662ca1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 49.999,
    cy: 50,
    rx: 6.874,
    ry: 8.594
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#662ca1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M65.797,26.909c-3.355,3.358-8.797,3.355-12.152,0L26.909,53.645c3.358,3.357,3.355,8.797,0,12.152L34.2,73.09 c3.357-3.355,8.797-3.355,12.152,0L73.09,46.352c-3.357-3.355-3.355-8.795,0.002-12.154L65.797,26.909z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnMoney);
export default __webpack_public_path__ + "static/media/return-money.1cec36995b3fef2b716a3bd2ab0aeae2.svg";
export { ForwardRef as ReactComponent };